
define('text!modules/targeting/location/templates/empty_hyperlocal_message.html',[],function () { return '<div class=\'no-results grid-item\'>There are no geofences available. For more information on how to create a geofence please visit the <a href=\'https://kb.mediamath.com\' target="_blank">Knowledge Base</a>.</div>\n';});

